import { RerideDecision, type AttemptOperations } from "@/components/official/RerideDecision";
import { useState } from "react";
import { RunSheet } from "./RunSheet";
import { useOfficialWrite, type RiderSheetProps } from "@/components/official/shared";
const reasons = [
  "cable_failure",
  "boat_fault",
  "driver_error",
  "equipment",
  "interference",
  "other",
];
export function RerideSheet(props: RiderSheetProps) {
  const config = props.heat.judging.re_rides;
  const allowed = config?.reride_reasons ?? reasons;
  const [reason, setReason] = useState(allowed[0] ?? "");
  const [scope, setScope] = useState("attempt");
  const [ground, setGround] = useState("");
  const [resume, setResume] = useState("");
  const [operational, setOperational] = useState<AttemptOperations | null>(null);
  const { busy, error, write, execute, undo } = useOfficialWrite(props);
  return (
    <RunSheet
      title={operational?.reride ? "Re-ride decision" : "Grant re-ride"}
      close={props.onClose}
    >
      <p>
        {props.rider.name} · Attempt {props.rider.current_attempt}
      </p>
      {error && <p role="alert">{error}</p>}
      {undo}
      <RerideDecision
        transport={props.transport}
        attemptPath={`/api/competitions/${props.competitionId}/heats/${props.heat.id}/riders/${props.rider.heat_rider_id}/attempts/${props.rider.current_attempt}`}
        onSaved={props.onSaved}
        disabled={busy}
        heading={!operational?.reride}
        onState={setOperational}
      />
      {!operational?.reride && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void write(() =>
              execute("reride", {
                heat_rider_id: props.rider.heat_rider_id,
                attempt_number: props.rider.current_attempt,
                reason,
                scope,
                ...(ground ? { protected_ground: ground } : {}),
                ...(resume ? { resumed_from_ts_ms: Number(resume) } : {}),
              }),
            );
          }}
        >
          <label>
            Reason
            <select required value={reason} onChange={(e) => setReason(e.target.value)}>
              {allowed.map((r) => (
                <option key={r} value={r}>
                  {r.replaceAll("_", " ")}
                </option>
              ))}
            </select>
          </label>
          <label>
            Scope
            <select value={scope} onChange={(e) => setScope(e.target.value)}>
              <option value="attempt">This attempt</option>
              <option value="heat">Whole heat</option>
            </select>
          </label>
          {config?.reride_selection === "better_of" && (
            <label>
              Protected ground
              <select value={ground} onChange={(e) => setGround(e.target.value)}>
                <option value="">None</option>
                {["committee_equipment", "fast_boat_time", "slow_boat_time", "short_boat_time"].map(
                  (g) => (
                    <option key={g} value={g}>
                      {g.replaceAll("_", " ")}
                    </option>
                  ),
                )}
              </select>
            </label>
          )}
          {config?.allow_resume && (
            <label>
              Resume from (milliseconds)
              <input
                type="number"
                min="0"
                step="1"
                value={resume}
                onChange={(e) => setResume(e.target.value)}
              />
            </label>
          )}
          <button className="run-primary" disabled={busy || !reason}>
            Grant re-ride
          </button>
        </form>
      )}
      <button onClick={props.onClose}>Cancel</button>
    </RunSheet>
  );
}
